export default "__VITE_ASSET__9arT7v8d__"